<template>
<div>
    <div v-if="!loading && !error">
        <Breadcrumbs main="Admin" submain="Resources" title="Asset Detail" />

        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div class="row">
                <div class="col-sm-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="d-flex flex-column flex-lg-row" style="gap: 16px;">
                                <div class="image-portion d-flex flex-column justify-content-start align-items-start">
                                    <div class="mb-3" v-if="asset_details.status">
                                        <span v-if="asset_details.status == 'APPROVAL PENDING'">
                                            <b-badge pill variant="info">{{ asset_details.status }}</b-badge>
                                        </span>
                                        <span v-if="asset_details.status == 'UNDER MAINTENANCE'">
                                            <b-badge pill variant="warning">{{ asset_details.status }}</b-badge>
                                        </span>
                                        <span v-if="asset_details.status == 'ACTIVE'">
                                            <b-badge pill variant="success">{{ asset_details.status }}</b-badge>
                                        </span>
                                        <span v-if="asset_details.status == 'INACTIVE'">
                                            <b-badge pill variant="danger">{{ asset_details.status }}</b-badge>
                                        </span>
                                    </div>
                                    <div v-if="asset_details.image">
                                        <img :src="host + asset_details.image" alt="">
                                    </div>
                                    <div v-else>
                                        <img src="https://placehold.co/300" alt="">
                                    </div>

                                    <h5 class="mt-4">{{ asset_details.name }}</h5>

                                    <span class="mt-3">Asset ID: <span class="font-weight-bold" v-if="asset_details.ast_ID">{{ asset_details.ast_ID }}</span></span>
                                    <span class="mt-3">Asset Type: <span class="font-weight-bold" v-if="asset_details.type">{{ asset_details.type.name }}</span></span>
                                    <span class="mt-3">Price: <span class="font-weight-bold" v-if="asset_details.amount">{{ asset_details.amount }}</span></span>
                                    <span class="mt-3">Location: <span class="font-weight-bold" v-if="asset_details.location_details">
                                            <span v-if="asset_details.location_details">
                                                {{
                                                [
                                                    asset_details.location_details.name ? 'Block: ' + asset_details.location_details.name : '',
                                                    asset_details.location_details.camp ? 'Camp: ' + asset_details.location_details.camp.camp_name : '',
                                                    asset_details.location_details.area ? 'Area: ' + asset_details.location_details.area.area_name : '',
                                                    asset_details.location_details.district ? 'District: ' + asset_details.location_details.district.district_name : '',
                                                    asset_details.location_details.country ? 'Country: ' + asset_details.location_details.country.country_name : ''
                                                ].filter(Boolean).join(', ')
                                            }}
                                            </span>
                                        </span></span>
                                    <span class="mt-3">Address Line: <span class="font-weight-bold" v-if="asset_details.address_line">{{ asset_details.address_line }}</span></span>
                                    <span class="mt-3">Manufacture Date: <span class="font-weight-bold" v-if="asset_details.manufacture_date">{{ asset_details.manufacture_date }}</span></span>
                                    <span class="mt-3">Purchase Date: <span class="font-weight-bold" v-if="asset_details.purchase_date">{{ asset_details.purchase_date }}</span></span>
                                    <span class="mt-3">Warranty End: <span class="font-weight-bold" v-if="asset_details.warranty_end">{{ asset_details.warranty_end }}</span></span>
                                    <span class="mt-3">Warranty Remaining: <span class="font-weight-bold text-primary" v-if="asset_details.warranty_end">{{ getWarrantyRemaining(asset_details.warranty_end) }} days</span></span>
                                </div>
                                <div class="feature-portion mt-4" style="display: flex; flex-direction: column;">
                                    <div class="d-flex justify-content-end mb-3">
                                        <button class="btn btn-secondary btn-sm" @click="printQR">Print QR</button>
                                    </div>

                                    <!-- print this div -->
                                    <div>
                                        <span class="mt-4">Asset ID: <span class="font-weight-bold" v-if="asset_details.ast_ID">{{ asset_details.ast_ID }}</span></span>
                                        <div class="id-card-qr mt-4">
                                            <img :src="qrSrc" v-if="qrSrc" alt="QR Code" width="150" height="150" />
                                            <div class="qr-label">Scan to verify</div>
                                        </div>
                                        <span class="mt-4 d-flex flex-column" style="gap: 8px;" v-if="asset_details.location_details">
                                            <span v-if="asset_details.address_line">Address Line: {{ asset_details.address_line }}</span>
                                            <span v-if="asset_details.location_details.name">Block: {{ asset_details.location_details.name }}</span>
                                            <span v-if="asset_details.location_details.camp">Camp: {{ asset_details.location_details.camp.camp_name }}</span>
                                            <span v-if="asset_details.location_details.area">Area: {{ asset_details.location_details.area.area_name }}</span>
                                            <span v-if="asset_details.location_details.district">District: {{ asset_details.location_details.district.district_name }}</span>
                                            <span v-if="asset_details.location_details.country">Country: {{ asset_details.location_details.country.country_name }}</span>
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div style="margin-top: 24px;">
                                <div class="mt-lg-4" v-if="asset_details.details">
                                    {{ asset_details.details }}
                                </div>
                            </div>

                            <h6 class="mb-3 mt-5" v-if="asset_details.specification != null">Asset Specifications</h6>
                            <div class="table-container" v-if="asset_details.specification != null">
                                <div class="table-responsive datatable-vue">
                                    <b-table show-empty stacked="md" :items="parsedDetails()" :fields="fields">
                                        <template #cell(id)="row">
                                            {{ row.index + 1 }}
                                        </template>
                                        <template #cell(name)="row">
                                            <div style="width: 250px;">{{ row.item.name }}</div>
                                        </template>
                                    </b-table>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <div class="content-container-attahment w-100">
                                        <div class="mt-5 mb-2">
                                            <h6 v-if="asset_details.asset_attach?.length > 0" class="mb-3">Asset Attachment</h6>
                                            <div class="table-responsive datatable-vue">
                                                <b-table show-empty stacked="md" :items="asset_details.asset_attach" :fields="Attachment" v-if="asset_details.asset_attach?.length > 0">
                                                    <template #cell(index)="data">
                                                        {{ data.index + 1 }}
                                                    </template>

                                                    <template #cell(title)="data">
                                                        <a :href="host + data.item.asset_attachment" target="_blank">{{ data.item.attach_title }}
                                                            <br />
                                                            <small v-if="data.item.note" style="font-style: italic;">Note:{{truncateText(data.item.note, 30)  }}</small>
                                                        </a>
                                                    </template>

                                                    <template #cell(action)="data">
                                                        <div style="display: flex; flex-direction: row; gap:10px">
                                                            <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover title="Delete" @click="deleteAttach(data.item.id)"></feather>
                                                        </div>
                                                    </template>
                                                </b-table>
                                            </div>

                                            <button v-if="asset_details.asset_attach?.length > 0" class="btn btn-primary" v-b-modal.modal-scrollable-add-document>Upload More</button>
                                            <button v-else class="btn btn-primary" v-b-modal.modal-scrollable-add-document>Add Attachment</button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <h6 class="mt-5 mb-3" v-if="asset_details.volunteer?.length > 0">Assigned Volunteers</h6>
                            <div style="display: flex; flex-wrap: wrap; gap: 10px;" v-if="asset_details.volunteer?.length > 0">
                                <div v-for="user in asset_details.volunteer" :key="user.id" v-b-tooltip.hover v-b-modal.modal-center-assetallocation @click="deleteAssetAllocation(user.id)" title="Delete" style="width: fit-content;">
                                    <div class="mb-2 badge-style">
                                        <div style="display: flex; flex-direction: column; gap: 2px;">
                                            <h7>{{ user.user_name }}</h7>
                                            <h7>{{ user.additional_info?.nid }}</h7>
                                            <h7>{{ user.email }}</h7>
                                            <h7>{{ user.additional_info?.phone_number }}</h7>
                                        </div>
                                        <b-icon icon="x" style="color: white;"></b-icon>
                                    </div>
                                </div>
                            </div>

                            <div class="mt-5" v-if="asset_details.remarks?.history?.length >= 1">
                                <h6 class="mb-3">Remarks</h6>
                                <div class="accordion">
                                    <div v-for="(item, index) in asset_details.remarks.history" :key="item.id" class="acc-item" :class="{ open: openIndex === index }">
                                        <div class="acc-header" @click="toggle(index)">
                                            <div style="display: flex; align-items: center; gap: 12px;">
                                                <span>{{ formatDate(item.created_at).date }} | {{ formatDate(item.created_at).time }}</span>
                                                <span v-if="item.status == 'APPROVAL PENDING'">
                                                    <b-badge pill variant="info">{{ item.status }}</b-badge>
                                                </span>
                                                <span v-if="item.status == 'UNDER MAINTENANCE'">
                                                    <b-badge pill variant="warning">{{ item.status }}</b-badge>
                                                </span>
                                                <span v-if="item.status == 'ACTIVE'">
                                                    <b-badge pill variant="success">{{ item.status }}</b-badge>
                                                </span>
                                                <span v-if="item.status == 'INACTIVE'">
                                                    <b-badge pill variant="danger">{{ item.status }}</b-badge>
                                                </span>
                                            </div>
                                            <svg class="acc-chevron" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                                                <polyline points="3,6 8,11 13,6" />
                                            </svg>
                                        </div>

                                        <transition name="accordion">
                                            <div v-show="openIndex === index">
                                                <div class="acc-content">
                                                    <p style="font-size: 14px;">{{ item.remark }}</p>
                                                    <ul class="feature-list">
                                                        <li v-for="feature in item.items" :key="feature.id" class="feature-item">
                                                            <span class="feature-icon" :class="feature.response ? 'icon-tick' : 'icon-cross'">
                                                                <svg v-if="feature.response" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                                                    <polyline points="2.5,8.5 6,12 13.5,4" />
                                                                </svg>
                                                                <svg v-else viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                                                    <line x1="4" y1="4" x2="12" y2="12" />
                                                                    <line x1="12" y1="4" x2="4" y2="12" />
                                                                </svg>
                                                            </span>
                                                            <span class="feature-label">{{ feature.feature }}</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </transition>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Container-fluid Ends-->

        <!-- Asset Allocate Delete Modal -->
        <b-modal id="modal-center-assetallocation" centered hide-header @ok="handleAllocationDeleteOk">
            <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this asset allocation?</div>
        </b-modal>

        <!-- Project Attachment Create -->
        <b-modal id="modal-scrollable-add-document" ref="modal" title="Add document" @ok="handleAttachOk">
            <form ref="form" @submit.stop.prevent="handleAttahmentSubmit">
                <div class="row">
                    <div class="col">
                        <div class="form-group">
                            <label>Upload Attachment</label>
                            <b-form-file placeholder="Choose files  or drop them here..." drop-placeholder="Drop file here..." @change="uploadAttachFile"></b-form-file>
                        </div>
                    </div>
                </div>
            </form>
        </b-modal>
    </div>
    <div v-else style="width: 100%;">
        <div class="container-fluid">
            <div class="row flex-md-row-reverse">
                <div class="loader-wrapper">
                    <div class="loader-index">
                        <span></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import {
    myHost
} from "../../../_helpers/host";
import QRCode from 'qrcode'

export default {
    data() {
        return {
            asset_allocation_id: '',
            host: myHost.host,
            fields: [{
                    key: 'id',
                    label: '#'
                },
                {
                    key: 'name',
                    label: 'Item',
                    sortable: false
                },
                {
                    key: 'description',
                    label: 'Description',
                    sortable: false
                }
            ],
            Attachment: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'title',
                    label: 'Title',
                    sortable: false
                },
                {
                    key: 'action',
                    label: 'Action',
                    sortable: false
                }
            ],
            add_attachment: {
                asset_attachment: null,
                asset_id: ''
            },
            qrSrc: null,
            openIndex: 0
        };
    },

    mounted() {
        this.$store.dispatch("asset/fetchAssetDetails", this.$route.params.id).then(() => {
            const assetId = this.asset_details ?.ast_ID
            if (assetId) {
                this.generate(String(assetId))
            }
        })
    },

    computed: {
        ...mapState({
            asset_details: state => state.asset.assetDetail,
            loading: state => state.asset.assetLoading,
            error: state => state.asset.assetError,
        })
    },

    watch: {
        asset_details(newValue, oldValue) {},

        'asset_details.specification': function (newVal, oldVal) {
            if (newVal !== oldVal) {
                this.parsedDetails();
            }
        }
    },

    methods: {
        toggle(index) {
            this.openIndex = index
        },

        formatDate(dateStr) {
            if (!dateStr) return ''

            // Split date and time manually
            const [datePart, timePart] = dateStr.replace('Z', '').split('T')

            const [year, month, day] = datePart.split('-')
            const [hourRaw, minute] = timePart.split(':')

            const hours = parseInt(hourRaw)

            const monthNames = [
                'January', 'February', 'March', 'April', 'May', 'June',
                'July', 'August', 'September', 'October', 'November', 'December'
            ]

            const monthName = monthNames[parseInt(month) - 1]

            const ampm = hours >= 12 ? 'PM' : 'AM'
            const hour12 = hours % 12 || 12

            const getOrdinal = (n) => {
                const s = ['th', 'st', 'nd', 'rd']
                const v = n % 100
                return s[(v - 20) % 10] || s[v] || s[0]
            }

            return {
                date: `${parseInt(day)}${getOrdinal(parseInt(day))} ${monthName}, ${year}`,
                time: `${hour12}:${minute} ${ampm}`
            }
        },

        async generate(text) {
            try {
                this.qrSrc = await QRCode.toDataURL(text, {
                    width: 120,
                    margin: 1
                })
            } catch (err) {
                console.error(err)
            }
        },

        truncateText(text, maxLength) {
            if (text.length > maxLength) {
                return text.substring(0, maxLength) + '...';
            } else {
                return text;
            }
        },

        getWarrantyRemaining(warrantyEndDate) {
            const endDate = new Date(warrantyEndDate);
            const currentDate = new Date();
            const timeDifference = endDate.getTime() - currentDate.getTime();
            const remainingDays = Math.ceil(timeDifference / (1000 * 3600 * 24)); // Convert milliseconds to days
            return remainingDays >= 0 ? remainingDays : 0;
        },

        parsedDetails() {
            try {
                if (!this.asset_details ?.specification) return [];
                if (Array.isArray(this.asset_details.specification)) {
                    return this.asset_details.specification;
                }

                let parsed = this.asset_details.specification;

                // Handle double-encoded JSON
                while (typeof parsed === 'string') {
                    parsed = JSON.parse(parsed);
                }

                return Array.isArray(parsed) ? parsed : [];
            } catch (error) {
                console.error('Error parsing details:', error);
                return [];
            }
        },

        deleteAssetAllocation(id) {
            this.asset_allocation_id = id
        },

        handleAllocationDeleteOk() {
            this.$store.dispatch("asset/deleteAssignedUser", {
                id: this.asset_allocation_id,
                asset_id: this.$route.params.id,
                from_detail: true
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.asset_allocation_id = null

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
            this.$nextTick(() => {
                this.$bvModal.hide('modal-center-assetallocation')
            })
        },

        uploadAttachFile(e) {
            this.add_attachment.asset_attachment = e.target.files[0]
        },

        handleAttachOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleAttahmentSubmit()
        },

        handleAttahmentSubmit() {
            this.add_attachment.asset_id = this.$route.params.id
            this.$store.dispatch("asset/addAssetAttachment", {
                attachment: this.add_attachment,
                asset_id: this.$route.params.id
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.add_attachment.asset_attachment = null
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-scrollable-add-document')
            })
        },

        deleteAttach(id) {
            this.$store.dispatch("asset/deleteAttachmentFromAsset", {
                id: id,
                asset_id: this.$route.params.id
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.delete_value = null
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        },

        printQR() {
            const printContents = this.$el.querySelector('.feature-portion > div:nth-child(2)').innerHTML;

            const printWindow = window.open('', '_blank', 'width=600,height=600');
            printWindow.document.write(`
                <!DOCTYPE html>
                <html>
                <head>
                    <title>Print QR</title>
                    
<style>
body {
    font-family: Arial, sans-serif;
    padding: 20px;
    font-size: 14px;
}

.id-card-qr {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 16px 0;
}

.qr-label {
    margin-top: 8px;
    font-size: 12px;
    color: #555;
}

.font-weight-bold {
    font-weight: bold;
}

.mt-4 {
    margin-top: 16px;
}

.mb-4 {
    margin-bottom: 16px;
}

.d-flex {
    display: flex;
}

.flex-column {
    flex-direction: column;
}
</style>
                </head>
                <body>
                    ${printContents}
                </body>
                </html>
            `);

            printWindow.document.close();
            printWindow.focus();

            const img = printWindow.document.querySelector('img');
            if (img && !img.complete) {
                img.onload = () => {
                    printWindow.print();
                    printWindow.close();
                };
            } else {
                printWindow.print();
                printWindow.close();
            }
        }
    }
};
</script>

<style scoped>
.asset-container {
    display: flex;
    flex-direction: row;
    gap: 32px
}

.image-portion {
    width: 50%;
}

.image-portion img {
    max-height: 400px;
}

.feature-portion {
    width: 50%;
}

.id-card-qr {
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: start;
}

.qr-label {
    font-size: 12px;
    color: #6c757d;
    text-align: center;
}

.accordion {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.acc-item {
    border: 0.5px solid #e0ddd6;
    border-radius: 6px;
    overflow: hidden;
    background: #ffffff;
    transition: border-color 0.2s;
}

.acc-item.open {
    border-color: #c4c1b8;
}

.acc-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 18px;
    cursor: pointer;
    user-select: none;
    gap: 12px;
}

.acc-header:hover {
    background: #f5f4f0;
}

.acc-chevron {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    color: #999;
    transition: transform 0.25s ease;
}

.acc-item.open .acc-chevron {
    transform: rotate(180deg);
}

.acc-content {
    padding: 14px 18px 16px;
    border-top: 0.5px solid #e0ddd6;
}

/* Accordion transition */
.accordion-enter-active,
.accordion-leave-active {
    transition: max-height 0.3s ease, opacity 0.25s ease;
    max-height: 300px;
    overflow: hidden;
}

.accordion-enter-from,
.accordion-leave-to {
    max-height: 0;
    opacity: 0;
}

.accordion-enter-to,
.accordion-leave-from {
    max-height: 300px;
    opacity: 1;
}

.feature-list {
  list-style: none;
  margin: 12px 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  border-top: 0.5px solid #e0ddd6;
  padding-top: 12px;
}
 
.feature-item {
  display: flex;
  align-items: center;
  gap: 10px;
}


.feature-icon {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
 
.feature-icon svg {
  width: 11px;
  height: 11px;
}
 
.icon-tick {
  background: #EAF3DE;
  color: #3B6D11;
}
 
.icon-cross {
  background: #FCEBEB;
  color: #A32D2D;
}

@media screen and (max-width: 991px) {
    .asset-container {
        display: flex;
        flex-direction: column;
    }

    .image-portion {
        width: 100%;
    }

    .feature-portion {
        width: 100%;
    }
}

.badge-style {
    display: flex;
    width: fit-content;
    gap: 20px;
    justify-content: space-between;
    align-items: center;
    justify-items: center;
    background-color: #2c323f;
    padding: 0.5rem 1rem;
    color: white;
    border-radius: 6px;
}

.badge-style:hover {
    background-color: #e4701e;
}
</style>
